import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import {
  collection,
  doc,
  getDoc,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
  startAt,
  endAt
} from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import Menu from '../../panel/Menu';
import moment from 'moment';

function Checkouthistory() {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });

  const [bookings, setBookings] = useState([]);
  const [allBookings, setAllBookings] = useState([]);
  const [userData, setUserData] = useState();
  const [username, setUsername] = useState();
  const [loading, setLoading] = useState(true);

  const [searchText, setSearchText] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);

  // Fetch user data
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      setUserData(user);
      fetchUserData(user);
    });
    return () => unsubscribe();
  }, []);

  const fetchUserData = async (user) => {
    try {
      if (user) {
        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setUsername(docSnap.data().username);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch bookings on mount or when date changes
  useEffect(() => {
    fetchBookings();
  }, [fromDate, toDate]);

  // Fetch bookings function with optional date range
  const fetchBookings = async (from, to) => {
    try {
      setLoading(true);
      let q;

      if (from) {
        const start = moment(from).startOf('day').toDate();
        const end = to ? moment(to).endOf('day').toDate() : moment(from).endOf('day').toDate();

        
        q = query(
          collection(db, 'bookings'),
          where('status', '==', 'Checkout'),
          where('checkoutdate', '>=', fromDate),
          where('checkoutdate', '<=', toDate),
          orderBy('checkoutdate', 'desc'),
          limit(1000)
        );
      } else {
        // Default last 1000 checkouts
        q = query(
          collection(db, 'bookings'),
          where('status', '==', 'Checkout'),
          orderBy('checkoutdate', 'desc'),
          limit(1000)
        );
      }

      onSnapshot(q, snapshot => {
        const data = snapshot.docs.map(doc => ({
          id: doc.id,
          data: doc.data()
        }));
        setAllBookings(data);
        filterData(data); // apply search filter
        setLoading(false);
      });
    } catch (error) {
      setLoading(false);
      Toast.fire({ icon: 'error', title: error.message });
    }
  };



  // Filter by search text
  useEffect(() => {
    filterData(allBookings);
  }, [searchText]);

  const filterData = (data) => {
    let filtered = data ? [...data] : [...allBookings];

    if (searchText) {
      filtered = filtered.filter(item =>
        item.data.customers.custname?.toLowerCase().includes(searchText.toLowerCase()) ||
        item.data.customers.mobile?.toLowerCase().includes(searchText.toLowerCase())
      );
    }

    setBookings(filtered);
    setCurrentPage(1);
  };

  // Pagination
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = bookings.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(bookings.length / rowsPerPage);

  return (
    <div>
      <Menu />
      <div className="content-wrapper bg-light py-3">
        <div className="container-fluid">
          <div className="card shadow-sm mb-3">
            <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Checkout History</h5>
              <span>{username ? `User: ${username}` : ''}</span>
            </div>

            <div className="card-body">
              <div className="row mb-3 g-2">
                <div className="col-md-3">
                  <input
                    type="date"
                    className="form-control"
                    value={fromDate}
                    onChange={e => setFromDate(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <input
                    type="date"
                    className="form-control"
                    value={toDate}
                    onChange={e => setToDate(e.target.value)}
                  />
                </div>
                <div className="col-md-2">
                  <button
                    className="btn btn-success w-100"
                    onClick={() => fetchBookings(fromDate, toDate)}
                  >
                    Fetch
                  </button>
                </div>
                <div className="col-md-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by name or mobile"
                    value={searchText}
                    onChange={e => setSearchText(e.target.value)}
                  />
                </div>
               
              </div>


              {/* Table */}
              <div className="table-responsive">
                {loading ? <p>Loading...</p> : (
                  <table className="table table-bordered table-hover table-striped">
                    <thead className="table-dark">
                      <tr>
                        <th>Sr No</th>
                        <th>Invoice No</th>
                        <th>Customer Name</th>
                        <th>Mobile</th>
                        <th>Checkin Date</th>
                        <th>Checkout Date</th>
                        <th>Rooms</th>
                        <th className="text-end">Total</th>
                        <th className="text-end">Paid</th>
                        <th className="text-end">Pending</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentRows.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{indexOfFirstRow + idx + 1}</td>
                          <td>{item.data.invoiceno}</td>
                          <td style={{ textTransform: "capitalize" }}>{item.data.customers.custname}</td>
                          <td>{item.data.customers.mobile}</td>
                          <td>{moment(item.data.checkindate).format('DD/MM/YYYY')}</td>
                          <td>{moment(item.data.checkoutdate).format('DD/MM/YYYY')}</td>
                          <td>
                            {item.data.rooms.map((r, i) => <span key={i}>{r.roomname} </span>)}
                          </td>
                          <td className="text-end">{parseFloat(item.data.totalamount).toFixed(2)}</td>
                          <td className="text-end">{parseFloat(item.data.advance).toFixed(2)}</td>
                          <td className="text-end">{parseFloat(item.data.remaining).toFixed(2)}</td>
                          <td>
                            <a href={`/print-invoice/${item.id}`} className="btn btn-info btn-sm">
                              <i className="fa fa-print"></i>
                            </a>
                          </td>
                        </tr>
                      ))}
                      {currentRows.length === 0 && <tr><td colSpan="11" className="text-center">No records found</td></tr>}
                    </tbody>
                  </table>
                )}
              </div>

              {/* Pagination */}
              <div className="d-flex justify-content-between align-items-center mt-3">
                <button
                  className="btn btn-outline-primary btn-sm"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(prev => prev - 1)}
                >Previous</button>
                <span>Page {currentPage} of {totalPages}</span>
                <button
                  className="btn btn-outline-primary btn-sm"
                  disabled={currentPage === totalPages || totalPages === 0}
                  onClick={() => setCurrentPage(prev => prev + 1)}
                >Next</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Checkouthistory;
